import * as types from './types';

const INITIAL_STATE = {
  grades: [],
  teachers: [],
  errors: null,
  loading: false,
  loadingGrades: false,
  report: null,
};

const allValue = { value: 'ALL', text: 'ALL' };

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.ROSTER_BALANCE_REPORT_GET_GRADES:
      const formattedGrades = payload.map(grade => {
        return {
          value: grade.Id,
          text: grade.Id + ' ' + grade.Description,
        };
      });
      formattedGrades.unshift(allValue);
      return { ...state, grades: formattedGrades };
    case types.ROSTER_BALANCE_REPORT_GET_TEACHERS:
      let formattedTeachers = payload.map(teacher => {
        return { value: teacher, text: teacher };
      });
      formattedTeachers.unshift(allValue);
      return { ...state, teachers: formattedTeachers };
    case types.ROSTER_BALANCE_REPORT_GET_REPORT:
      return { ...state, report: payload };
    case types.ROSTER_BALANCE_REPORT_LOADING:
      return { ...state, loading: payload };
    case types.ROSTER_BALANCE_REPORT_LOADING_GRADES:
      return { ...state, loadingGrades: payload };
    case types.ROSTER_BALANCE_REPORT_ERRORS:
      return { ...state, errors: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/rostercurrentbalance/state/roster/reducer.js